import { curso, regraDosDescontos } from '@curso/content/curso';

/**
 * As duvidas.
 *
 * Texto do roteiro de 19/10. A ordem importa: as tres primeiras respondem
 * "isto e para mim?", e so depois vem preco e logistica. Quem ainda nao se
 * reconheceu no curso nao se importa com o valor.
 *
 * Todo numero aqui vem interpolado de `curso`. Antes desta revisao as
 * respostas repetiam preco, carga, turma e prazo de acesso escritos a mao, e
 * foi assim que a pagina chegou a publicar tres meses de acesso depois que o
 * grupo ja tinha decidido doze.
 */
export interface Duvida {
  pergunta: string;
  resposta: string | null;
}

export const duvidas: Duvida[] = [
  {
    pergunta: 'Para quem é a Imersão HCRM?',
    resposta:
      'Para profissionais da saúde que atuam em ambientes complexos e de alta pressão: médicos, enfermeiros, fisioterapeutas, farmacêuticos e demais profissionais assistenciais. Também é indicada para gestores, lideranças, preceptores e profissionais que atuam com Qualidade, Segurança do Paciente e Gestão de Riscos. Não é necessário ocupar cargo de liderança para participar.',
  },
  {
    pergunta: 'Preciso conhecer HCRM ou TeamSTEPPS?',
    resposta:
      'Não. A formação foi estruturada para construir os conceitos progressivamente, das videoaulas à experiência prática.',
  },
  {
    pergunta: 'Preciso trabalhar no HCFMUSP?',
    resposta:
      'Não. A formação é aberta a profissionais de outras instituições, conforme os critérios de elegibilidade do curso.',
  },
  {
    pergunta: 'Como funciona a parte online?',
    resposta: `São ${curso.videoaulas}\u00a0videoaulas de aproximadamente ${curso.duracaoAula}, acompanhadas de materiais de apoio, dois encontros ao vivo e fórum de discussão. O acesso ao conteúdo gravado permanece disponível por ${curso.acesso}.`,
  },
  {
    pergunta: 'Preciso participar dos dois dias presenciais?',
    resposta: `Sim. A experiência prática corresponde a ${curso.horasPresenciais} das ${curso.cargaHoraria} da formação. Os cenários foram construídos em sequência ao longo dos dois dias.`,
  },
  {
    pergunta: 'Vou ser avaliado durante as simulações?',
    resposta:
      'As simulações têm finalidade de aprendizagem. O foco está na análise dos comportamentos, da comunicação e do funcionamento da equipe, não no julgamento do desempenho individual.',
  },
  {
    pergunta: 'Quantas pessoas haverá por turma?',
    resposta: `De ${curso.turma}, organizados em grupos menores durante os cenários. O tamanho reduzido da turma favorece participação ativa, observação e debriefing.`,
  },
  {
    pergunta: 'Quanto custa e quem tem desconto?',
    resposta: `${curso.preco} por inscrição. Há desconto de 10% para colaboradores do Complexo HCFMUSP, FFM, FZ e SES. Residentes, estagiários e pós-graduandos da FMUSP também têm 10%. Alunos e ex-alunos do EEP têm 5%, assim como o pagamento à vista. ${regraDosDescontos}`,
  },
  {
    pergunta: 'Há processo seletivo?',
    resposta:
      'Não há processo seletivo. Para matrícula, serão solicitados diploma ou certificado de conclusão de curso, curriculum vitae e comprovante de registro no conselho. A formação é destinada a profissionais da área da saúde.',
  },
  {
    pergunta: 'O curso oferece certificado?',
    resposta: `Sim. Será emitido certificado de curso de atualização, com carga horária de ${curso.cargaHoraria}, mediante cumprimento dos critérios de frequência e aproveitamento: 75% do conteúdo online, 100% de frequência no presencial e nota igual ou superior a 7 no pré e pós-teste.`,
  },
  {
    pergunta: 'Posso inscrever mais de um profissional da minha equipe?',
    resposta:
      'Sim! Incentivamos a participação de profissionais de uma mesma instituição, ampliando as oportunidades de aplicar os conhecimentos e ferramentas do HCRM no ambiente de trabalho. Para conhecer as condições especiais para inscrições institucionais, basta deixar seu contato na seção Investimento. Nossa equipe entrará em contato com você.',
  },
];
